import { List, ListItem } from "@vinomofo/components";
import {
  NumericMenuProvided,
  connectNumericMenu,
} from "react-instantsearch-core";
import { useMemo } from "react";

import CurrentFilterItem from "./CurrentFilterItem";
import { FilterGroup } from "./FilterGroup";
import FilterOption from "./FilterOption";
import { trackAddRemoveFilterEvent } from "../../utils/event-tracking";
import { useInstantSearch } from "../../hooks/use-instantsearch";
import { useLocation } from "@reach/router";

interface NumericMenuProps extends NumericMenuProvided {
  attribute: string;
  label: string;
  asCurrentFilter?: boolean;
}

export const NumericMenu = connectNumericMenu<NumericMenuProps>(
  ({
    label,
    items,
    refine,
    currentRefinement,
    asCurrentFilter,
    attribute,
  }: NumericMenuProps): JSX.Element => {
    const LOCATION = useLocation();
    const {
      setCarryOverFilter,
      carryOverFilter,
      searchState,
    } = useInstantSearch();
    const CURRENT_URL_FILTER = LOCATION?.search.replace(/query=[^&]+&?/, "");

    if (CURRENT_URL_FILTER) {
      if (carryOverFilter !== CURRENT_URL_FILTER && LOCATION?.search) {
        setCarryOverFilter(CURRENT_URL_FILTER);
      }
    } else setCarryOverFilter(CURRENT_URL_FILTER);

    return useMemo(
      () => (
        <>
          {asCurrentFilter ? (
            items
              .filter((f) => f?.count && f?.count > 0)
              .map((item, i) => (
                <CurrentFilterItem
                  key={i}
                  label={item?.label}
                  count={item?.count || 0}
                  onClick={(event) => {
                    event.preventDefault();
                    trackAddRemoveFilterEvent({
                      eventType: item.isRefined ? "remove" : "add",
                      searchState: searchState,
                      filter: {
                        type: attribute,
                        value: item.label,
                      },
                    });
                    refine(item.value);
                  }}
                />
              ))
          ) : (
            <FilterGroup
              label={label}
              initiallyOpened={currentRefinement?.length > 0}
            >
              <List margin="0" padding="0" listStyleType="none">
                {items.map((item, i) =>
                  item.value ? ( // We only show filter with value
                    <ListItem key={i}>
                      <FilterOption
                        type="checkbox"
                        label={item.label}
                        selected={item.isRefined}
                        onChange={(event: MouseEvent) => {
                          event.preventDefault();
                          trackAddRemoveFilterEvent({
                            eventType: item.isRefined ? "remove" : "add",
                            searchState: searchState,
                            filter: {
                              type: attribute,
                              value: item.label,
                            },
                          });
                          refine(item.isRefined ? null : item.value);
                          // refine(item.value);
                        }}
                        disabled={item.noRefinement && !item.isRefined}
                      />
                    </ListItem>
                  ) : null
                )}
              </List>
            </FilterGroup>
          )}
        </>
      ),
      [items]
    );
  }
);
